"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingHistoryRestService = void 0;
const BaseRestService_1 = __importDefault(require("../BaseRestService"));
const utils_1 = require("@sqvr/utils");
class MeetingHistoryRestService extends BaseRestService_1.default {
  constructor() {
    super(...arguments);
    this.basePath = '/meetings';
  }
  getMeetingHistory(request, paginationParams, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.send(utils_1.GET, paginationParams.commentId ? `count=${paginationParams.count}&comment_id=${paginationParams.commentId}` : `count=${paginationParams.count}`, `/${request.meetingId}/comments`, Object.assign({}, options), requestOptions);
    });
  }
  getMeetingRegistrationHistory(request, paginationParams, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.send(utils_1.GET, paginationParams.commentId ? `count=${paginationParams.count}&comment_id=${paginationParams.commentId}` : `count=${paginationParams.count}`, `/${request.meetingId}/participants/registration/history`, Object.assign({}, options), requestOptions);
    });
  }
  getMeetingVoteHistory(request, paginationParams, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.send(utils_1.GET, paginationParams.commentId ? `count=${paginationParams.count}&comment_id=${paginationParams.commentId}` : `count=${paginationParams.count}`, `/${request.meetingId}/bulletins/${request.bulletinId}/comments`, Object.assign({}, options), requestOptions);
    });
  }
  getMeetingAdminPanelHistory(request, options = {}, requestOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.send(utils_1.GET, '', `/${request.meetingId}/admin_panel/history`, Object.assign({}, options), requestOptions);
    });
  }
}
exports.MeetingHistoryRestService = MeetingHistoryRestService;
const meetingHistoryRestService = new MeetingHistoryRestService();
exports.default = meetingHistoryRestService;